import { observer } from "mobx-react-lite";
import type React from "react";
import { useTranslation } from "react-i18next";

import { useStores } from "@stores";

import { BN } from "@utils/BN";

import { ValueText } from "./styled";

// ---------------------------------------------------------------------------
// Observer sub-component: SliderAvailableLabel
// Isolates reads of portfolio.available_balance so the slider doesn't
// re-render on every portfolio update — only this tiny label does.
// ---------------------------------------------------------------------------
const SliderAvailableLabel: React.FC = observer(() => {
  const { t } = useTranslation();
  const { accountStore, marketStore } = useStores();
  const portfolio = accountStore.portfolio;
  const formatted = portfolio ? new BN(portfolio.available_balance).toFormat(2) : "0";

  return (
    <ValueText data-testid="tradebox:available">
      <span data-testid="tradebox:available:value">{t("tradebox.available")}</span> {formatted}{" "}
      <span data-testid="tradebox:available:symbol">{marketStore.quoteToken?.symbol}</span>
    </ValueText>
  );
});

// Stable element reference — created once, observer inside handles reactivity
export const SLIDER_RIGHT_LABEL = <SliderAvailableLabel />;
